import { StackName } from '../../store/web3-clients-store';

export function detectStack(): StackName {
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const hasInjected = typeof window !== 'undefined' && !!(window as any).ethereum;

  if (hasInjected) return StackName.WAGMI; // default: use injected when available
  return StackName.PRIVY;
}
